import { useQuery } from 'react-query';
import { FeaturedReview } from 'rwl-shared/dist/models';
import { useAPIRoute } from '../../hooks/useAPIRoute';
import { useGlobal } from '../../hooks';

type UseFetchReviewParams = {
    reviewId?: string;
    enabled: boolean;
};

export const useFetchReview = ({ reviewId, enabled }: UseFetchReviewParams) => {
    const { accountId } = useGlobal();
    const url = useAPIRoute('serviceareas/featured/review', 'v1');

    return useQuery<FeaturedReview>(
        ['useFetchReview', accountId, reviewId],
        async () => {
            if (!reviewId || !accountId) {
                return undefined;
            }
            try {
                const result = await fetch(
                    `${url}?` +
                        new URLSearchParams({
                            accountId: accountId,
                            reviewId: reviewId,
                        }),
                    {
                        method: 'GET',
                    }
                );

                return result.json();
            } catch (e) {
                console.error('useFetchReview error:', e);
                throw e;
            }
        },
        {
            enabled: !!reviewId && !!accountId && enabled,
            staleTime: 1000 * 60 * 60 * 24, // 24 hours
            cacheTime: 1000 * 10,
        }
    );
};
